import classNames from 'classnames';
import { RefObject } from 'react';
import { twMerge } from 'tailwind-merge';

import { isMobile } from '@growtherapy/analytics';

import { Browser } from '../../../types';
import { detectBrowser } from '../../../utils';
import { LocalScreenShareComponentProps, RemoteScreenShareComponentProps } from '../../core/types';

export function ZoomLocalScreenShare({ videoRef }: LocalScreenShareComponentProps) {
  const isMobileDevice = isMobile(navigator.userAgent);
  const className = twMerge(
    classNames('relative max-w-full sm:w-unset fs-exclude display-block max-h-full', { 'sm:w-full': isMobileDevice }),
  );
  const testId = 'screenshare-video';
  const isFirefox = detectBrowser() === Browser.Firefox;

  return (
    <div className='w-full h-full flex items-center justify-center'>
      {isFirefox ? (
        <canvas className={className} data-testid={testId} ref={videoRef as RefObject<HTMLCanvasElement>} />
      ) : (
        <video // eslint-disable-line  jsx-a11y/media-has-caption
          className={className}
          data-testid={testId}
          ref={videoRef as RefObject<HTMLVideoElement>}
        />
      )}
    </div>
  );
}

/**
 * Screen share must use a different parent video-player-container
 */
export function ZoomRemoteScreenShare({ videoRef }: RemoteScreenShareComponentProps) {
  return (
    <video-player-container class='w-[min(100vw,1280px)]'>
      <video-player data-testid='screenshare-video' style={{ width: '100%' }} ref={videoRef} />
    </video-player-container>
  );
}
